const match = {
    id: null,
    idSelected: null,
    date: '',
    opponent: '',
    price: '',
    start_request: '',
    end_request: '',
    competizione: '',
    ref_partita: '',
    adult_vs_childs: 1,
    tickets_threshold: 15,
    sectors: []
};

export default match
